import * as i from "../../../../../contracts";
import { renderScore } from "../RenderMethods";
import { scoreHelper } from "../../../../../helpers/scoreHelper/scoreHelper";

export const renderLiveScore = (event: i.Event) => {
    const score = scoreHelper(event);
    return renderScore(score.homeScore, score.awayScore, event.sportId, event.scoreboard)
}